import { render, staticRenderFns } from "./ExternalLinkSelector.vue?vue&type=template&id=275473f0&scoped=true"
import script from "./ExternalLinkSelector.vue?vue&type=script&lang=js"
export * from "./ExternalLinkSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275473f0",
  null
  
)

export default component.exports